import ModalCommon from 'components/Input/ModalCommon';
import React, { useState } from 'react';
import { Spin } from 'antd';
import Button from 'components/Button';

const ChangePassSuccessModal = ({ isOpen, onClose }) => {
  const [loading] = useState(false);
  return (
    <ModalCommon
      width={679}
      height={308}
      title="パスワード変更"
      open={isOpen}
      onSubmit={onClose}
      onCancel={onClose}
      footer={
        <div className="flex h-[56px] w-full justify-end gap-4 border-t border-[#E6EBF1]">
          <Button
            style={{ marginTop: 16, width: 120, height: 40, fontSize: 14 }}
            type="primary"
            onClick={onClose}
          >
            OK
          </Button>
        </div>
      }
    >
      <Spin spinning={loading}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: 20,
          }}
        >
          <div
            style={{
              textAlign: 'center',
              height: 130,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#000000',
              fontSize: 15,
              fontWeight: 400,
            }}
          >
            パスワードが無事に変更されました。
          </div>
        </div>
      </Spin>
    </ModalCommon>
  );
};

export default ChangePassSuccessModal;
